import { FEATURES } from '/src/features/_global/constants';

export const FUNNEL_PERMISSIONS = {
  [FEATURES.FUNNEL]: ({ capabilities }) => ({
    navigate: capabilities?.funnels.permissions.nav,
    view: capabilities?.funnels.permissions.view,
  }),
};
